import AllRoutes from "./routes";
import axios from "axios";
import { toast } from "react-toastify";
import "leaflet/dist/leaflet.css";
import "./leafletIconFix";
// import { useEffect } from "react";

function App() {
  // for disable inspect
  // useEffect(() => {
  //   // 1️⃣ Right-click disable
  //   document.addEventListener("contextmenu", (e) => e.preventDefault());

  //   // 2️⃣ Keyboard shortcuts block
  //   const handleKeyDown = (e) => {
  //     if (
  //       e.key === "F12" || // F12
  //       (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "i") || // Ctrl+Shift+I
  //       (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "j") || // Ctrl+Shift+J
  //       (e.ctrlKey && e.key.toLowerCase() === "u") // Ctrl+U
  //     ) {
  //       e.preventDefault();
  //       // alert("Inspect is disabled on this page!");
  //     }
  //   };

  //   document.addEventListener("keydown", handleKeyDown);

  //   // 3️⃣ Cleanup on unmount
  //   return () => {
  //     document.removeEventListener("contextmenu", (e) => e.preventDefault());
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, []);
  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response?.status === 406 || error.response?.status === 401) {
        const currentPath = window.location.pathname;
        const isAdminRoute = currentPath.startsWith("/admin");
        const isLoginPage =
          currentPath === "/login" || currentPath === "/admin/login";
        // Only redirect if not already on login page to prevent infinite loop
        if (!isLoginPage) {
          sessionStorage.clear();
          toast.error("Session Expired!!", {
            position: "top-center",
          });
          localStorage.removeItem("name");
          localStorage.removeItem("user_id");
          localStorage.removeItem("user_email");
          localStorage.removeItem("user_type");
          localStorage.removeItem("is_register");
          localStorage.removeItem("is_active");
          localStorage.removeItem("token");
          // Redirect to appropriate login page based on current route
          window.location.href = isAdminRoute ? "/admin/login" : "/login";
        }
      }
      return Promise.reject(error);
    }
  );

  return <AllRoutes />;
}

export default App;
